import { styled } from '../../../utils/styled'
import Grid from '../../Grid'
import { LARGE_AVATAR_WIDTH_PX, MEDIUM_AVATAR_WIDTH_PX, SMALL_AVATAR_WIDTH_PX } from '../Avatar/styles'
import { type Size } from '../Avatar/types'
import { AVATAR_CLASS_NAME } from '../classNames'

const AVATAR_GROUP_GAP_PX = 4
const AVATAR_GROUP_OVERLAP_PX = 6

const getAvatarGroupWidth = (size: Size, max: number, numberOfChildren: number): string => {
  const baseMultiplier = Math.min(max + 1, numberOfChildren)
  const avatarWidthPx =
    size === 'large' ? LARGE_AVATAR_WIDTH_PX : size === 'medium' ? MEDIUM_AVATAR_WIDTH_PX : SMALL_AVATAR_WIDTH_PX

  if (max >= numberOfChildren) {
    const gapToAdd = AVATAR_GROUP_GAP_PX * (baseMultiplier - 1)
    return `${avatarWidthPx * baseMultiplier + gapToAdd}px`
  } else {
    const overlapToSubtract = AVATAR_GROUP_OVERLAP_PX * (baseMultiplier - 1)
    return `${avatarWidthPx * baseMultiplier - overlapToSubtract}px`
  }
}

export const StyledGridAvatarGroupRoot = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'hasExtraAvatars' && prop !== 'numberOfChildren'
})(
  ({
    hasExtraAvatars,
    max,
    size,
    numberOfChildren
  }: {
    hasExtraAvatars: boolean
    size: Size
    max: number
    numberOfChildren: number
  }) => ({
    display: 'flex',
    width: getAvatarGroupWidth(size, max, numberOfChildren),
    gap: hasExtraAvatars ? undefined : `${AVATAR_GROUP_GAP_PX}px`,
    [`.${AVATAR_CLASS_NAME}`]: {
      margin: hasExtraAvatars ? '0px -3px' : undefined
    },
    [`.${AVATAR_CLASS_NAME}:first-of-type`]: {
      marginLeft: '0px'
    },
    [`.${AVATAR_CLASS_NAME}:last-child`]: {
      marginRight: '0px'
    }
  })
)
